import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class HeaderService {

    constructor(private http: HttpClient) { }

    GetMenus(roleId: number, menuType: string, enterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}menu/GetMenus?roleId=${roleId}&menuType=${menuType}&enterpriseId=${enterpriseId}`)
    }
    GetCurrentLocation()
    {
     return JSON.parse(sessionStorage.getItem('currentLocation'));
    }
   
    // loadNotifications() {
    //     //console.log("Getting New Notifications!");
    //     // if (this.localStorageService.get('TowCompanyId') != null) {
    //     if (this.localStorageService.get('XrefId') != null) {
    //         // this.TowCompanyId = this.localStorageService.get('TowCompanyId');
    //         this.TowCompanyId = this.localStorageService.get('XrefId');
    //         this.UserId = this.localStorageService.get('UserId');
    //         this._dataService.get(Global.BASE_API_URL + 'Request/SelectRequestNotification?TowCompanyId=' + Number(this.TowCompanyId) + '&UserId=' + this.UserId)
    //             .subscribe(Rlist => {

    //                 this.pendingnotifications = [];
    //                 this.cancelednotifications = [];
    //                 this.pendingpushnotifications = [];
    //                 this.canceledpushnotifications = [];
    //                 this.notesnotifications = [];
    //                 this.newtownotifications = [];
    //                 this.callnotifications = [];
    //                 this.callpushnotifications = [];
    //                 this.serviceRequestnotifications = [];
    //                 this.hpdnotifications = [];
    //                 this.hpdpushnotifications = [];
    //                 this.gptxnotifications = [];
    //                 this.gptxpushnotifications = [];
    //                 Rlist.forEach(appObj => {
    //                     if (appObj.StatusId == 1) {
    //                         this.pendingnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.RequestDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         if (appObj.ShowNotification == 1) {
    //                             this.pendingpushnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.RequestDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         }
    //                     } else if (appObj.StatusId == 8) {
    //                         this.cancelednotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.DispatchCancelDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         if (appObj.ShowNotification == 1) {
    //                             this.canceledpushnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.RequestDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         }
    //                     }
    //                     else if (appObj.StatusId == 9) {
    //                         this.callnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.DispatchCancelDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         if (appObj.ShowNotification == 1) {
    //                             this.callpushnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.RequestDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         }
    //                     }
    //                     else if (appObj.StatusId == 0) {
    //                         this.notesnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.RequestDate, Url: "/dispatchlist?type=d&Id=" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom, ShortNote: appObj.SNote });
    //                     }
    //                     else if (appObj.StatusId == 12) {
    //                         this.serviceRequestnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.RequestStatus, DateTime: appObj.RequestDate, Url: "/servicerequestlist", TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom, ShortNote: appObj.SNote });
    //                     }
    //                     else if (appObj.StatusId == 13) {
    //                         this.hpdnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.DispatchCancelDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         if (appObj.ShowNotification == 1) {
    //                             this.hpdpushnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.RequestDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         }
    //                     }
    //                     else if (appObj.StatusId == 14) {
    //                         this.gptxnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.DispatchCancelDate, Url: "/request/" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom });
    //                         if (appObj.ShowNotification == 1) {
    //                             this.gptxpushnotifications.push({ GuidID: appObj.GuidID, RequestId: appObj.RequestId, RequestNumber: appObj.RequestNumber, Status: appObj.StatusId, DateTime: appObj.RequestDate, Url: "/dispatchlist?type=d&Id=" + appObj.GuidID, TowCompany: appObj.TowcompanyName, TowedFrom: appObj.TowedFrom,NotificationMsg: appObj.SNote  });
    //                         }
    //                     }
    //                 });

    //                 // this.notificationscount = this.pendingnotifications.length + this.cancelednotifications.length;
    //                 this.notificationscount = this.pendingnotifications.length + this.canceledpushnotifications.length + this.notesnotifications.length + this.callnotifications.length + this.serviceRequestnotifications.length + this.hpdnotifications.length + this.gptxnotifications.length;//+ this.newtownotifications.length;
    //                 this.pendingdiffarr = this.arrayDifference(this.pendingpushnotifications, this.oldpendingnotifications);
    //                 if (this.pendingdiffarr.length > 0) {
    //                     this.pendingdiffarr.forEach(val => {
    //                         //this.notify();
    //                         this.doNotification(val.RequestId, val.RequestNumber, "pend");
    //                         // setTimeout(() => {
    //                         //     this.audio.pause();
    //                         //     this.audio.currentTime = 0;
    //                         // }, 1000);
    //                     });
    //                 }

    //                 this.oldpendingnotifications = this.pendingpushnotifications;

    //                 this.calldiffarr = this.arrayDifference(this.callpushnotifications, this.oldcallnotifications);
    //                 if (this.calldiffarr.length > 0) {
    //                     this.calldiffarr.forEach(val => {
    //                         //this.notify();
    //                         this.doNotification(val.RequestId, val.RequestNumber, "call");
    //                         // setTimeout(() => {
    //                         //     this.audio.pause();
    //                         //     this.audio.currentTime = 0;
    //                         // }, 1000);
    //                     });
    //                 }
    //                 this.hpddiffarr = this.arrayDifference(this.hpdpushnotifications, this.oldhpdnotifications);
    //                 if (this.hpddiffarr.length > 0) {
    //                     this.hpddiffarr.forEach(val => {
    //                         //this.notify();
    //                         this.doNotification(val.RequestId, val.RequestNumber, "hpd");
    //                         // setTimeout(() => {
    //                         //     this.audio.pause();
    //                         //     this.audio.currentTime = 0;
    //                         // }, 1000);
    //                     });
    //                 }
    //                 this.oldhpdnotifications = this.hpdpushnotifications;

    //                 this.gptxdiffarr = this.arrayDifference(this.gptxpushnotifications, this.oldgptxnotifications);
    //                 if (this.gptxdiffarr.length > 0) {
    //                     this.gptxdiffarr.forEach(val => {
    //                         //this.notify();
    //                         this.doNotification(val.RequestId, val.NotificationMsg, "gptx");
    //                         // setTimeout(() => {
    //                         //     this.audio.pause();
    //                         //     this.audio.currentTime = 0;
    //                         // }, 1000);
    //                     });
    //                 }
    //                 this.oldgptxnotifications = this.gptxpushnotifications;

    //                 this.oldcallnotifications = this.callpushnotifications;
    //                 this.canceleddiffarr = this.arrayDifference(this.canceledpushnotifications, this.oldcancelednotifications);

    //                 if (this.canceleddiffarr.length > 0) {
    //                     this.canceleddiffarr.forEach(val => {
    //                         //this.notify();
    //                         this.doNotification(val.RequestId, val.RequestNumber, "can");
    //                         // setTimeout(() => {
    //                         //     this.audio.pause();
    //                         //     this.audio.currentTime = 0;
    //                         // }, 1000);
    //                     });
    //                 }

    //                 this.notesdiffarr = this.arrayDifference(this.notesnotifications, this.oldnotesnotifications);
    //                 if (this.notesdiffarr.length > 0) {
    //                     this.notesdiffarr.forEach(val => {
    //                         this.doNotesNotification(val.RequestId, val.RequestNumber);
    //                     });
    //                 }
    //                 this.oldnotesnotifications = this.notesnotifications;
    //                 this.oldcancelednotifications = this.canceledpushnotifications;


    //                 this.newServiceRequestdiffarr = this.arrayDifference(this.serviceRequestnotifications, this.oldServiceRequestnotifications);
    //                 if (this.newServiceRequestdiffarr.length > 0) {
    //                     this.newServiceRequestdiffarr.forEach(val => {
    //                         this.doServiceRequestNotification(val.RequestId, val.RequestNumber);
    //                     });
    //                 }

    //                 this.oldServiceRequestnotifications = this.serviceRequestnotifications;
    //                 /* this.newtowdiffarr = this.arrayDifference(this.newtownotifications, this.oldnewtownotifications);
    //                  if (this.newtowdiffarr.length > 0) {
    //                      this.newtowdiffarr.forEach(val => {                            
    //                          this.doNewTowNotification(val.RequestId, val.RequestNumber);                           
    //                      });
    //                  }
    //                  this.oldnewtownotifications = this.newtownotifications;*/

    //             });
    //     }
    // }
}